
import { HttpClient } from '@angular/common/http';
import { Directive, Inject, inject, Input, DOCUMENT } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { DictionaryAPIService } from '../../../commons/services/dictionary-api.service';
import { StoreService } from '../../../commons/stores/store.service';
import { TvLoginStore } from '../services/app.store';

@Directive({
  selector: '[custom-css]',
  standalone: false,
})
export class CustomCssDirective {
  readonly tvLoginStore = inject(TvLoginStore);
  @Input() ClientCssModel: string;

  constructor(
    @Inject(DOCUMENT) document,
    private storeService: StoreService,
    private dictionaryAPIService: DictionaryAPIService,
    private http: HttpClient
  ) {
    const linkElem = document.createElement('link');
    linkElem.setAttribute('rel', 'stylesheet');
    document.getElementsByTagName('head')[0].appendChild(linkElem);

    toObservable(this.tvLoginStore.customCss)
      .pipe(
        switchMap((isCustomCss) => {
          if (isCustomCss) {
            const url = this.dictionaryAPIService.customizationColorScheme(this.storeService.client.id);
            return this.http.get(url);
          } else {
            linkElem.removeAttribute('href');
            return of(null);
          }
        }),
        tap((file: { id: string }) => {
          if (!!file) {
            const fileUrl = this.dictionaryAPIService.fileDownload(file.id);
            linkElem.setAttribute('href', fileUrl);
          }
        })
      )
      .subscribe();
  }
}
